import store from '@/store';
import { LUDUM_ERROR_CODES } from '@/constants';
const { PARTIAL_CONTENT } = LUDUM_ERROR_CODES;

export function downloadURI(url, filename) {
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export function downloadFile(url, filename) {
    fetch(url)
        .then(response => response.blob())
        .then(blob => {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            link.click();
        })
        .catch(console.error);
}

export function isElementInViewport(id, elem) {
    const element = document.getElementById(id) || elem;
    if (!element) return;

    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    const { top, left, bottom, right } = element.getBoundingClientRect();
    return top >= 0 && left >= 0 && bottom <= viewportHeight && right <= viewportWidth;
}

export function handleResponsePrivacy(response) {
    if (response.status_code === PARTIAL_CONTENT && response.message) {
        const message = { ...response, persist: true };
        store.dispatch('notifyError', message);
    }
}
